<template>
  <el-table
    v-loading="loading"
    :data="data"
    :stripe="true"
    size="small"
  >
    <el-table-column
      label="Name"
      :formatter="row => $_.get(row, 'name') || '-'"
    />
    <el-table-column
      label="Description"
      :formatter="row => $_.get(row, 'description') || '-'"
    />
    <el-table-column
      label="Created at"
      prop="created_at"
      :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('llll') : '-'"
    />
    <el-table-column
      label="Update at"
      prop="updated_at"
      :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('llll') : '-'"
    />
    <el-table-column
      v-if="columns.includes('actions')"
      label="Actions"
      align="right"
    >
      <template
        slot-scope="prop"
      >
        <slot
          name="action"
          :type="prop.row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>

export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: false,
      default: () => {
        return [
          'actions'
        ]
      }
    }
  },
  data () {
    return {
      loading: true
    }
  }
}
</script>
